export default "__VITE_ASSET__DHcNv1ff__"